import { render, staticRenderFns } from "./MatchNewsSection.vue?vue&type=template&id=5d5d7802&scoped=true"
import script from "./MatchNewsSection.vue?vue&type=script&lang=js"
export * from "./MatchNewsSection.vue?vue&type=script&lang=js"
import style0 from "./MatchNewsSection.vue?vue&type=style&index=0&id=5d5d7802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d7802",
  null
  
)

export default component.exports